import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { FormInput } from "../../../../components/FormInput";
import { FormInputFile } from "../../../../components/FormInputFile";

export const AddManufacture = ({ 
    register, errors, control, setValue,
    fileInputRef,
}) =>{
    const { t } = useTranslation();
    const solidUnitsList = [
        { label: '公克(g)', value: "g" },
        { label: '公斤(kg)', value: "kg" },
        { label: '公噸(t)', value: "t" },
    ]
    const handleFileChange = (e) => {}

    return(
        <form className="grid">
            <div className="col-12 lg:col-3">
                <label htmlFor="" className="required form-label">種類</label>
                <Controller
                    name="type"
                    control={control}
                    // rules={{ required: { value: true, message: t('validation.required') } }}
                    render={({ field, fieldState }) => (
                        <Dropdown
                            // appendTo={"self"}
                            optionLabel="label"
                            optionValue="value"
                            value={field.value}
                            // virtualScrollerOptions={{ itemSize: 40 }}
                            defaultValue={""}
                            placeholder={t("plz_chs")}
                            name="type"
                            control={control}
                            options={[{ label: '主要原物料& 輔助物料', value: 0 }, { label: '資源投入(水源)', value: 1 }]}
                            className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                            onChange={(event) => {
                                field.onChange(event.value);
                            }}
                        />
                    )} />
            </div>
            <div className="col-12 lg:col-3">
                    <FormInput
                        register={register}
                        errors={errors}
                        id="name"
                        name="name"
                        type="text"
                        labelText="項目名稱"
                        labelClass="required"
                    />
                </div>
            <div className="col-12 lg:col-2">
                <FormInput
                    register={register}
                    errors={errors}
                    id="value"
                    name="value"
                    type="number"
                    labelText="數值"
                    labelClass="required"
                />
            </div>
            <div className="col-12 lg:col-2">
                <label htmlFor="" className="required form-label">{t('unit')}</label>
                <Controller
                    name="unit"
                    control={control}
                    // rules={{ required: { value: true, message: t('validation.required') } }}
                    render={({ field, fieldState }) => (
                        <Dropdown
                            // appendTo={"self"}
                            optionLabel="label"
                            optionValue="value"
                            value={field.value}
                            // virtualScrollerOptions={{ itemSize: 40 }}
                            defaultValue={""}
                            placeholder={t("plz_chs")}
                            name="unit"
                            control={control}
                            options={solidUnitsList}
                            className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                            onChange={(event) => {
                                field.onChange(event.value);
                                // setValue(`addressItems.${index}.zipcodeSeq`, "")
                            }}
                        />
                    )} />
            </div>
            <div className="col-12 lg:col-2">
                <FormInput
                    register={register}
                    errors={errors}
                    id="ratio"
                    name="ratio"
                    type="number"
                    labelText="使用比例"
                    labelClass="required"
                />
            </div>
            <div className="col-12 lg:col-5">
                <FormInput
                    register={register}
                    errors={errors}
                    id="TransportationStarting"
                    name="TransportationStarting"
                    type="text"
                    labelText="運輸起點"
                    labelClass="required"
                />
            </div>
            <div className="col-12 lg:col-2">
                <label htmlFor="" className="required form-label">運輸方式</label>
                <Controller
                    name="transportation"
                    control={control}
                    // rules={{ required: { value: true, message: t('validation.required') } }}
                    render={({ field, fieldState }) => (
                        <Dropdown
                            // appendTo={"self"}
                            optionLabel="label"
                            optionValue="value"
                            value={field.value}
                            // virtualScrollerOptions={{ itemSize: 40 }}
                            defaultValue={""}
                            placeholder={t("plz_chs")}
                            name="transportation"
                            control={control}
                            options={[{label:'運輸卡車',value:0},{label:'飛機',value:1},{label:'貨輪',value:2}]}
                            className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                            onChange={(event) => {
                                field.onChange(event.value);
                                // setValue(`addressItems.${index}.zipcodeSeq`, "")
                            }}
                        />
                    )} />
            </div>
            <div className="col-12 lg:col-3">
                <FormInput
                    register={register}
                    errors={errors}
                    id="transportationValue"
                    name="transportationValue"
                    type="text"
                    labelText="單趟運輸距離"
                    labelClass="required"
                />
            </div>
            <div className="col-12 lg:col-2">
                <label htmlFor="" className="required form-label">{t('unit')}</label>
                <Controller
                    name="transportationUnit"
                    control={control}
                    // rules={{ required: { value: true, message: t('validation.required') } }}
                    render={({ field, fieldState }) => (
                        <Dropdown
                            // appendTo={"self"}
                            optionLabel="label"
                            optionValue="value"
                            value={field.value}
                            // virtualScrollerOptions={{ itemSize: 40 }}
                            defaultValue={""}
                            placeholder={t("plz_chs")}
                            name="transportationUnit"
                            control={control}
                            options={[{label:'公尺(m)',value:'m'},{label:'公里(km)',value:'km'},{label:'海哩(um)',value:'um'}]}
                            className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                            onChange={(event) => {
                                field.onChange(event.value);
                                // setValue(`addressItems.${index}.zipcodeSeq`, "")
                            }}
                        />
                    )} />
            </div>
            <div className="col-12">
                <FormInput
                    register={register}
                    errors={errors}
                    id="remark"
                    name="remark"
                    type="text"
                    labelText={t('remark')}
                />
            </div>
            {/* 附圖/附件 */}
            <div className='col-12'>
                <label
                    htmlFor="customFile"
                    className="form-label">
                    {`${t('attached_picture')}/${t('attachments')}`}
                </label>

                <FormInputFile
                    register={register}
                    errors={errors}
                    acceptFileType=".jpg,.png,.pdf"
                    id="customFile"
                    name="customFile"
                    limitSize="20MB"
                    fileChange={(e) => { handleFileChange(e) }}
                    fileInputRef={fileInputRef}
                />

                {/* {
                    getValues("fileExtension") !== 'zip' && (
                        <ImagePDFComponent
                            wrapperClass='mt-2'
                            file={fileInfo}
                            previewUrl={previewUrl}
                            zoomSrc={zoomSrc}
                            disabled={false}
                            deleteImg={handleDeleteImg}
                        />
                    )
                } */}

                {/* {
                    (watch("fileExtension") === 'zip') && (
                        <div className="flex flex-wrap lg:flex-nowrap align-items-center">
                            <label>{watch("fileName")}{watch("fileName") !== '' ? '.' : ''}{watch("fileExtension")}</label>
                            <Button
                                type='button'
                                icon="pi pi-trash"
                                tooltip={t('button.delete')} tooltipOptions={{ position: 'top' }}
                                className='p-button-icon-only' rounded text
                                severity="danger"
                                onClick={(e) => { handleDeleteImg(e) }}>
                            </Button>

                            <Button rounded text severity="secondary"
                                className="p-button-icon-only" type="button"
                                tooltip={t('button.download')} tooltipOptions={{ position: 'top' }}
                                onClick={() => { downloadItem(cusObj) }}>
                                <FontAwesomeIcon icon="fa-solid fa-cloud-arrow-down" />
                            </Button>
                        </div>
                    )
                } */}

            </div>
        </form>
    )
}